import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD__tensor_latents } from '../../_fields/_tensor/FIELD__tensor_latents';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION__latents_blend extends INVOCATION__base {
  /*
   * FIELDS
   */

  @FIELD__tensor_latents.init_as_input()
  latents_a!: FIELD__tensor_latents;

  @FIELD__tensor_latents.init_as_input()
  latents_b!: FIELD__tensor_latents;

  @FIELD__image_asset.init_as_input({}, { data__is_required: false })
  mask!: FIELD__image_asset;

  @FIELD_PRIMITIVE__float.init_as_input({ value: 0.5, values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE })
  alpha!: FIELD_PRIMITIVE__float;

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.LATENTS_BLEND);
  }
}
